<template>
    <footer>
        <p class="legal">&copy; {{ new Date().getFullYear() }} {{ appname }}</p>
        <p class="colophon"><a href="https://digitalbridge.com.au/">Website Design</a> by Digital Bridge</p>
    </footer>
</template>

<script>
    export default {
        props: [ 'appname', 'nav' ],

        computed: {
            menu () {
                return JSON.parse(this.nav)
            }
        },

        mounted() {
        }
    }
</script>

<style lang="scss" scoped>

</style>
